export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/brand_style_guides.e9493de.svg";